import React from 'react';

import { useStore } from '@/store/store';

interface TestModeBannerProps {
  className?: string;
}

export const TestModeBanner: React.FC<TestModeBannerProps> = ({ className = '' }) => {
  const { testModeEnabled } = useStore();

  // Don't show banner if test mode is not active
  if (!testModeEnabled) {
    return null;
  }

  return (
    <div
      className={`
        fixed left-0 right-0 z-[9999] top-0
        ${className}
      `}
      role="alert"
      aria-live="polite"
    >
      {/* Thin orange bar */}
      <div className="w-full h-1 bg-orange-500"></div>

      {/* Centered badge/pill */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
        <div className="bg-orange-500 text-primary-foreground px-6 py-1 rounded-b-md shadow-sm">
          <p className="text-xs font-semibold">DEVELOPER MODE</p>
        </div>
      </div>
    </div>
  );
};
